import trim from "lodash/trim";
import { Flex } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { ObjectWithProfileName } from "PFCore/helpers/profile";
import { useIsUnbiasedMode } from "PFCore/hooks";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Activity, Profile } from "PFTypes";

import css from "./workforce_member_cell.module.scss";

type ProfileWithNameAndEmail = ObjectWithProfileName &
  Pick<Profile, "email"> & {
    [key: string]: unknown;
  };

type WorkforceMemberCellProps = {
  profile: ProfileWithNameAndEmail;
  activity: Activity;
};

export const WorkforceMemberCell = ({ profile, activity }: WorkforceMemberCellProps) => {
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const profileFullName = getUnbiasedProfileName(profile, isUnbiasedMode);
  const title = trim(`${profileFullName} ${isUnbiasedMode ? "" : profile.email}`);

  return (
    <Flex direction="column" justifyContent="start" gap={null} className={css.root} title={title}>
      <Typography withMargin variant="bodyBold" tag="span">
        {profileFullName}
      </Typography>
      {!isUnbiasedMode && (
        <Typography withMargin variant="labelRegular" tag="span" textOverflow="clip">
          {profile.email}
        </Typography>
      )}
    </Flex>
  );
};
